import { useMemo } from "react";
import { ClientSettingFeatures } from "../../model/reference/settingsTypes";
import { createDefaultsChecker } from "./createDefaultsChecker";

export const useDefaultsChecker = (features: ClientSettingFeatures) =>
  useMemo(() => createDefaultsChecker(features), [features]);
